$(document).ready(function () {
    if ($('.amigos__carousel')) {
        $('.amigos__carousel').slick(
            {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 1441,
                        settings: {
                            slidesToShow: 1,
                            arrows: false,
                            dots: true,
                        }
                    }
                ]
            }
        );
    }

    if ($('.green-years__carousel').length) {
        $('.green-years__carousel').slick({
            slidesToShow: 2,
            variableWidth: true,
            slidesToScroll: 1,
            infinite: true,
            speed: 700,
            autoplaySpeed: 7000,
            arrows: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false,
                    variableWidth: true
                }
            }]
        });
    }

    $('body').on('click', '[data-modal="h2Modal"]', function () {
        console.log('click');
        $('.overlay, #h2Modal').fadeIn('slow'); //при нажатии на кнопку появляется модальное окно
    });


    $('.h2modal_close').on('click', function () {
        $('.overlay, #h2Modal').fadeOut('slow'); //при нажатии на крестик закрываю блок
    });
});